import { useEffect, useState } from 'react';
import {
  ACTIVE_DEPLOYED_ENV,
  DEPLOYMENT_ENV_TYPE_DEV,
  DEPLOYMENT_ENV_TYPE_PROD,
  DEPLOYMENT_ENV_TYPE_UAT,
  RECOMMENDATION_RESULTS_PROD_API_ENDPOINT,
  RECOMMENDATION_RESULTS_UAT_API_ENDPOINT,
  RECOMMENDATION_RESULTS_DEV_API_ENDPOINT
} from './globalApi';
import { CommonApiforJourney } from './RecommendationApi';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

export const recommendationResponse = async () => {
  const viewRecommendationData = JSON.parse(localStorage.getItem('viewRecommendation'));
  if (viewRecommendationData !== null) {
    let endpoint = '';
    if (ACTIVE_DEPLOYED_ENV === DEPLOYMENT_ENV_TYPE_PROD) {
      endpoint = RECOMMENDATION_RESULTS_PROD_API_ENDPOINT;
    } else if (ACTIVE_DEPLOYED_ENV === DEPLOYMENT_ENV_TYPE_UAT) {
      endpoint = RECOMMENDATION_RESULTS_UAT_API_ENDPOINT;
    } else if (ACTIVE_DEPLOYED_ENV === DEPLOYMENT_ENV_TYPE_DEV) {
      endpoint = RECOMMENDATION_RESULTS_DEV_API_ENDPOINT;
    }
    const responseData = await CommonApiforJourney(
      'GET',
      `${endpoint}/?partner_recommendation_id=${viewRecommendationData.recommendationId}&sort_by=loan_amount`,
      'tokenNotRequired',
      '',
      ''
    );
    if (responseData.status === 'success' || responseData.action_status === 'success') {
      responseData.data.forEach((item, indexno) => {
        item.showLimit = false;
        if (indexno < 2) {
          item.showLimit = true;
        }
      });
      return responseData.data;
    } else if (responseData.status === 'error') {
      return {
        loader: false,
        open: true,
        message: responseData.msg
      };
    }
  }
};
export default function OfflineApplicationResponse({ applicationId }) {
  const { LoginData } = useLoginSelector();

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOfflineApplication = async () => {
      if (!LoginData) return;

      setLoading(true);

      const companyIdObj = {
        companyId: LoginData?.companyId,
        userId: LoginData?.userId,
        applicationId
      };

      try {
        const responseData = await CommonApiforJourney(
          'POST',
          'offline-v2/get-loan-application-by-id',
          JSON.stringify(companyIdObj),
          LoginData?.jwt
        );

        if (responseData.status === 'success' || responseData.action_status === 'success') {
          setData(responseData.data.journeyConfigs.journeyModel.journeyReviewWizard);
        } else {
          setError(responseData);
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    if (applicationId) {
      fetchOfflineApplication();
    }
  }, [applicationId]);

  return (
    <div>
      <h3>Journey Review Wizard</h3>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}
